import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Field } from 'redux-form';
import { useFlags } from 'launchdarkly-react-client-sdk';
import {
  renderCurrencyField,
  renderCLCurrencyField,
} from '../../../../../utils/redux-form-helper';
import messages from './messages';

export const OneTimeLeaseChargesOrCreditsLeftColumn = ({
  intl,
  isEditable,
  handleAutoFilledFieldChange,
  autoFilledLeaseChargeFields,
}: Object) => {
  const getBackgroundColor = (fieldName) =>
    autoFilledLeaseChargeFields[fieldName] ? 'warning.lighter' : undefined;
  const { automatedLeaseChargesP1 } = useFlags();
  return (
    <Col xs={12} sm={6}>
      <Row>
        <Col xs={7}>
          <label>{intl.formatMessage(messages.securityDepositLabel)}</label>
        </Col>
        <Col xs={5}>
          <div className="form-group">
            <Field
              name="securityDeposit"
              component={
                automatedLeaseChargesP1
                  ? renderCLCurrencyField
                  : renderCurrencyField
              }
              step="0.01"
              disabled={!isEditable}
              onChange={(_, value) => {
                if (!automatedLeaseChargesP1) {
                  return;
                }

                handleAutoFilledFieldChange('securityDeposit', value);
              }}
              InputProps={
                automatedLeaseChargesP1 && {
                  sx: {
                    backgroundColor: getBackgroundColor('securityDeposit'),
                  },
                }
              }
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={7}>
          <label>{intl.formatMessage(messages.proratedRentLabel)}</label>
        </Col>
        <Col xs={5}>
          <div className="form-group">
            <Field
              name="proratedRent"
              component={
                automatedLeaseChargesP1
                  ? renderCLCurrencyField
                  : renderCurrencyField
              }
              step="0.01"
              disabled={!isEditable}
              onChange={(_, value) => {
                if (!automatedLeaseChargesP1) {
                  return;
                }

                handleAutoFilledFieldChange('proratedRent', value);
              }}
              InputProps={
                automatedLeaseChargesP1 && {
                  sx: { backgroundColor: getBackgroundColor('proratedRent') },
                }
              }
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={7}>
          <label>{intl.formatMessage(messages.proratedOtherLabel)}</label>
        </Col>
        <Col xs={5}>
          <div className="form-group">
            <Field
              name="proratedOther"
              component={
                automatedLeaseChargesP1
                  ? renderCLCurrencyField
                  : renderCurrencyField
              }
              step="0.01"
              disabled={!isEditable}
              InputProps={
                automatedLeaseChargesP1 && {
                  sx: { backgroundColor: getBackgroundColor('proratedOther') },
                }
              }
            />
          </div>
        </Col>
      </Row>
    </Col>
  );
};
